

import { toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';

import {
  Button, TextField, InputAdornment, Select, MenuItem, Divider,
  InputLabel, FormControl
} from '@material-ui/core';

import Prompt from '../../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../../Shared/Prompt/Actions';

import { decodeHTMLEntities } from '../../../../../Functions/utils';

import { toastTimerValue } from '../../../../../Shared/utils';
import { create } from '../../../../../Functions/admin';
import { useAppContext } from '../../../../../Context/App/Provider';
// import { useReportingContext } from '../../../../Context/Reporting/Provider';

// import { getTemplates, uploadTemplate, downloadTemplate } from '../../../../Functions/admin';
// import { apiUrl, config } from '../../../../Shared/config';

import '../../../../SweetAlert.css'

export default function CreatePageSize({ setAddPageSizePanelVisible, setForceReloadCustomeSizes }) {

  const { t } = useTranslation();
  const [{ user, settings }, appDispatch] = useAppContext();

  const [loading, setLoading] = useState(false);

  const [newPageSize, setNewPageSize] = useState({
    widthValue: 10,
    widthUnit: 'cm',
    heightValue: 10,
    heightUnit: 'cm',
  });


  const handleCreatePageSize = (e, pageSize) => {

    const pageSizeText = pageSize.widthValue + pageSize.widthUnit + ' x ' +  pageSize.heightValue + pageSize.heightUnit;

    const newPageSize = {
      ...pageSize,
      pageSizeText: pageSizeText
    };

    e.preventDefault();
    setLoading(true);

    console.log("52 - handleCreatePageSize=", pageSize);

    //<Width><unit> x <Height><unit>
    

    create({ type: 'pagesize', pagesize: newPageSize }).then(res => {
      setLoading(false);

      if (!res.success) {
        setAddPageSizePanelVisible(false);
        return toast(decodeHTMLEntities(t('admin.pagesize.errors.' + res, { name: pageSize.name })), { type: 'error' });

        // return Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.pagesize.errors.' + res, { name: pageSize.name }),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }

      // setSelectedReport(null);
      toast(decodeHTMLEntities(t('admin.pagesize.create_success', { name: pageSize.name })), { type: 'success' });

      // Swal.fire({
      //   toast: true,
      //   icon: 'success',
      //   title: t('admin.pagesize.create.success', { name: pageSize.name }),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });

      // console.log("114 - newPageSize=", newPageSize);
      setForceReloadCustomeSizes(newPageSize.pageSizeText);
      setAddPageSizePanelVisible(false);
      // setLoadedReport(false);
    });
  };



  // console.log("107 - newReport=", newReport, templates, ext);

  return (
    <Prompt animated>
      <form
        className="prompt__container animated"
        onSubmit={e => {
          // console.log("318 - e=", e);
          handleCreatePageSize(e, newPageSize)
          //setNewReport({ ...newReport, pageSize: null })
          // setAddPageSizePanelVisible(false);
        }}
      >
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.reports.addCustomPageSize')}</h1>
          </div>

          <div className="prompt__content">
            <div className="flexRow">
              <div style={{ paddingTop: '18px', paddingLeft: '50px', color: '#555', fontSize: '20px', width: '35%' }}>
                {t('global.width')}
              </div>

              <div style={{ width: '40%' }}>
                <TextField
                  required
                  variant="standard"
                  type="number"
                  style={{ width: '100%' }}
                  value={newPageSize.widthValue}
                  label={t('admin.reports.custom_pagesize.value')}
                  onChange={e => {
                    if (e.target.value && !isNaN(e.target.value))
                      setNewPageSize({ ...newPageSize, widthValue: e.target.value })
                  }}
                />
              </div>

              <div style={{ width: '25%' }}>
                <FormControl variant="standard" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.reports.custom_pagesize.unit')}</InputLabel>
                  <Select
                    label={t('admin.reports.custom_pagesize.unit')}
                    value={newPageSize.widthUnit}
                    onChange={e => setNewPageSize({ ...newPageSize, widthUnit: e.target.value })}
                  >
                    <MenuItem value={'cm'}>cm</MenuItem>
                    <MenuItem value={'mm'}>mm</MenuItem>
                    <MenuItem value={'in'}>in</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            <div className="flexRow">
              <div style={{ paddingTop: '18px', paddingLeft: '50px', color: '#555', fontSize: '20px', width: '35%' }}>
                {t('global.height')}
              </div>

              <div style={{ width: '40%' }}>
                <TextField
                  required
                  variant="standard"
                  type="number"
                  style={{ width: '100%' }}
                  value={newPageSize.heightValue}
                  label={t('admin.reports.custom_pagesize.value')}                 
                  onChange={e => {
                    if (e.target.value && !isNaN(e.target.value))
                      setNewPageSize({ ...newPageSize, heightValue: e.target.value })
                  }}
                />
              </div>

              <div style={{ width: '25%' }}>
                <FormControl variant="standard" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.reports.custom_pagesize.unit')}</InputLabel>
                  <Select
                    label={t('admin.reports.custom_pagesize.unit')}
                    value={newPageSize.heightUnit}
                    onChange={e => setNewPageSize({ ...newPageSize, heightUnit: e.target.value })}
                  >
                    <MenuItem value={'cm'}>cm</MenuItem>
                    <MenuItem value={'mm'}>mm</MenuItem>
                    <MenuItem value={'in'}>in</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setAddPageSizePanelVisible(false)}>
            {t('global.cancel')}
          </Button>

          <Button
            className="btnPrimary"
            type="submit"
            // disabled={loading || !loaded}
            disabled={loading || newPageSize.widthValue === "" || newPageSize.heightValue === ""}
          >
             {loading ? <BeatLoader color="white" css="transform:translateY(4px)" /> : t('global.create')}
          </Button>
        </PromptActions>
      </form>
    </Prompt >
  );

}
